import { z } from "zod";
import { baseEntitySchema } from "./base";

export const SPECIAL_ATTRIBUTE_COLORS = [
  "#EF4444", // red-500
  "#F59E0B", // amber-500
  "#10B981", // emerald-500
  "#3B82F6", // blue-500
  "#8B5CF6", // violet-500
  "#EC4899", // pink-500
  "#6B7280", // gray-500
  "#14B8A6", // teal-500
] as const;

export type SpecialAttributeColor = (typeof SPECIAL_ATTRIBUTE_COLORS)[number];

export const specialAttributeColorSchema = z.enum(SPECIAL_ATTRIBUTE_COLORS);

export const specialAttributeDataSchema = z.object({
  name: z.string().min(1).max(64),
  color: specialAttributeColorSchema,
});

export type SpecialAttributeData = z.infer<typeof specialAttributeDataSchema>;
export const specialAttributeSchema = baseEntitySchema.merge(
  specialAttributeDataSchema,
);
export type SpecialAttribute = z.infer<typeof specialAttributeSchema>;
